import { map } from 'rxjs/operators';
import { filter, Observable, of } from 'rxjs';
import { Customer, CustomerNameGQL, Maybe } from '@iss/libs/graphql';
import {
  ChangeDetectorRef,
  inject,
  OnDestroy,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';

@Pipe({ name: 'customerName', pure: false, standalone: true })
export class CustomerNamePipe implements PipeTransform, OnDestroy {
  private readonly customerName = inject(CustomerNameGQL);
  private readonly asyncPipe = new AsyncPipe(inject(ChangeDetectorRef));
  private id?: Maybe<Customer['id']>;
  private customerName$!: Observable<string | null>;

  public transform(id: Maybe<Customer['id']>): string | null {
    if (this.id !== id) {
      this.id = id;
      this.customerName$ = id ? this.fetch(id) : of(null);
    }

    return this.asyncPipe.transform(this.customerName$);
  }

  public ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }

  protected fetch(id: Customer['id']): Observable<string> {
    return this.customerName.fetch({ id }).pipe(
      map(({ data }) => data),
      filter(Boolean),
      map(({ customer }) => customer.organization.name),
    );
  }
}
